import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';       /// Change Language

@Component({
  selector: 'app-acc-master',
  templateUrl: './acc-master.component.html',
  styleUrls: ['./acc-master.component.css']
})
export class AccMasterComponent implements OnInit {

  constructor(public translate: TranslateService,) { }

  ngOnInit(): void {
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }
}
